<template>
  <ZMainPage type="card" :loading="loading">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">基础信息</span>
      </div>
      <LineWrapper list column="3" label-width="170rem">
        <LineItem v-for="item in list" :key="item.label" :label="item.label">
          <span class="mr-1" v-if="item.value">{{ item.value }}</span>
          <span class="text-primary c-p" v-if="item.button" @click="handlePreview(item.type)">{{ item.button }}</span>
        </LineItem>
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">缴费详情</span>
        <template v-if="diff_fee_tag.length">
          <ZuTips v-if="item.name" :value="item.name" :type="item.type === 1 ? 'red' : 'orange'" v-for="(item, idx) in diff_fee_tag" :key="idx" />
        </template>
      </div>
      <el-form label-width="200rem" label-position="left" :rules="rules" :model="formData" ref="formRef">
        <el-row>
          <el-col span="8">
            <el-form-item label="应缴金额">{{ money_answer }}</el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="是否缴费" prop="is_pay">
              <el-select v-model="formData.is_pay" placeholder="请选择是否缴费">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="8" v-if="formData.is_pay===1">
            <el-form-item label="是否分期" prop="is_by_stages">
              <el-select v-model="formData.is_by_stages" placeholder="请选择是否分期" @change="onStageChange">
                <el-option label="否" :value="0"></el-option>
                <el-option label="部分欠缴" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="formData.is_pay===2">
          <el-form-item style="margin-bottom: 0;"></el-form-item>
          <el-form-item label="驳回原因" prop="reason">
            <el-input v-model="formData.reason" maxlength="300" placeholder="请输入驳回原因" rows="8" show-word-limit style="width: 790rem" type="textarea"></el-input>
            <div>
              <ZuTips value="驳回后，家长端订单将自动取消，请谨慎操作!" type="info" showIcon />
            </div>
          </el-form-item>
        </template>
        <template v-else>
          <el-row>
            <template v-if="formData.is_by_stages">
              <el-col span="8">
                <el-form-item style="margin-bottom: 0;"></el-form-item>
                <el-form-item label="实缴金额" prop="sum_price">
                  <el-input v-model="formData.sum_price" placeholder="请输入实缴金额" @change="onAmountChange"></el-input>
                </el-form-item>
              </el-col>
              <el-col span="8">
                <el-form-item style="margin-bottom: 0;"></el-form-item>
                <el-form-item label="欠缴金额" prop="sum_remain_price">
                  <el-input v-model="formData.sum_remain_price" disabled placeholder="请输入实缴金额"></el-input>
                </el-form-item>
              </el-col>
            </template>
            <template v-else>
              <el-col span="8">
                <el-form-item label="实缴金额">{{ money_answer }}</el-form-item>
              </el-col>
            </template>
          </el-row>
          <el-form-item v-if="showMethod" label="实缴金额及方式" class="z-no-margin-bottom mb-2">
            <div class="z-dynamic-list-item" v-for="(domain, index) in formData.payment_detail" :key="domain.id">
              <div class="flex z-dynamic-list-inner">
                <el-form-item labelWidth="0" :prop="`payment_detail.${index}.paid_amount`" :rules="dynamicNumber">
                  <el-input v-model="domain.paid_amount" placeholder="请输入学生缴费金额"></el-input>
                </el-form-item>
                <div class="px-2 text-gray">-</div>
                <el-form-item labelWidth="0" :prop="`payment_detail.${index}.payment_method`" :rules="dynamicSelect">
                  <el-select v-model="domain.payment_method" placeholder="请选择学生缴费方式">
                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <div class="px-2 text-gray">-</div>
                <el-form-item labelWidth="0" :prop="`payment_detail.${index}.payer`" :rules="dynamicInput">
                  <el-input v-model="domain.payer" placeholder="请输入付款人姓名" maxlength="20"></el-input>
                </el-form-item>
                <div class="px-2 text-gray">-</div>
                <el-form-item :prop="`payment_detail.${index}.payment_at`" :rules="dynamicData" labelWidth="0">
                  <el-date-picker v-model="domain.payment_at" placeholder="请选择缴费时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
              </div>
              <el-form-item label-width="40rem">
                <el-button icon="el-icon-delete" circle v-if="formData.payment_detail.length !== 1" @click.prevent="handelRemove(domain)"></el-button>
                <el-button icon="el-icon-plus" circle v-if="formData.payment_detail.length !== dynamicMaxlength && index === formData.payment_detail.length - 1" @click="handleAdd"></el-button>
              </el-form-item>
            </div>
            <ZuTips :value="sumAmount" type="info" showIcon />
          </el-form-item>
          <el-row>
            <el-col span="15">
              <el-form-item label="备注">
                <el-input v-model="formData.remark" maxlength="300" placeholder="请输入" rows="8" show-word-limit type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
    </div>
    <template slot="footer">
      <template v-if="formData.is_pay !== 2">
        <el-button @click="handleClick('formRef')" type="primary">通过</el-button>
        <!-- <el-button @click="handleClick('formRef', false)" type="warning">暂存</el-button> -->
      </template>
      <el-button @click="handleClick('formRef')" type="primary" v-if="formData.is_pay!==1">驳回</el-button>
      <el-button @click="handleBack">返回</el-button>
    </template>
  </ZMainPage>
</template>

<script>
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ZuTips from '@/components/common/ZuTips'
import http from '@/api'
import { validateNumber, verifyIsNumber } from '@/utils/validate'
import { formDataBackMixin } from '@/utils/mixins'
import { transformAddOrEditData, preciseAdd, preciseSubtract, objectIsEmpty, formatDate } from '@/utils'
import { orderPayMethod } from '@/utils/data'
export default {
	_config:{'route':{'path':'edit-xf','meta':{'title':'审批'}}},
  components: { LineWrapper, LineItem, ZuTips },
  mixins: [formDataBackMixin],
  data() {
    const validateS = (rule, value, callback) => {
      const v = verifyIsNumber(value, { empty: '请输入实缴金额', positive: true })
      if (v) return callback(new Error(v))
      let str = ''
      if (Number(value) >= Number(this.money_answer)) {
        str = '实缴金额需要小于应缴金额'
      }
      if (str) return callback(new Error(str))
      callback()
    }
    return {
      loading: false,
      money_answer: 0,
      list: [],
      formData: {
        is_pay: 1,
        is_by_stages: 0,
        sum_price: '',
        sum_remain_price: '',
        payment_detail: [],
        reason: '',
        remark: ''
      },
      rules: {
        is_pay: [{ required: true, message: '请选择是否缴费', trigger: 'change' }],
        is_by_stages: [{ required: true, message: '请选择是否分期', trigger: 'change' }],
        reason: [{ required: true, message: '请输入驳回原因', trigger: 'blur' }],
        sum_price: [{ required: true, validator: validateS, trigger: 'blur' }],
        sum_remain_price: [{ required: true, message: '请输入实缴金额', trigger: 'blur' }]
      },
      diff_fee_tag: [],
      typeOptions: [],
      dynamicMaxlength: 15,
      dynamicSelect: { required: true, message: '请选择学生缴费方式', trigger: 'change' },
      dynamicInput: { required: true, message: '请输入付款人姓名', trigger: 'blur' },
      dynamicData: {required: true, message: '请选择缴费时间', trigger: 'blur'},
      dynamicNumber: { required: true, validator: (_, value, callback) => validateNumber(value, callback, { min: 0, equalToMin: true, empty: '请输入学生缴费金额' }), trigger: 'blur' }
    }
  },
  computed: {
    showMethod() {
      if(this.formData.sum_price !== '') {
        if (Number(this.formData.sum_price) === 0) return false
      }
      return true
    },
    sumAmount() {
      const arr = this.formData.payment_detail.filter(i => i.paid_amount)
      const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
      if (isNaN(sum)) return '请输入数字'
      return `累计实缴金额：${sum}`
    },
  },
  created() {
    this.getConfig()
    this.getData()
    this.handleAdd()
  },
  methods: {
    getConfig() {
      this.typeOptions = orderPayMethod()
    },
    getData() {
      this.loading = true
      http({ url: '/recruit-v2/order-offline/show?id=' + this.$route.query.id, pre: 'zs'}).then((res) => {
          this.money_answer = res.money_answer
          this.diff_fee_tag = res.tag || []
          const list = [
            { label: '订单编号', value: res.order_number },
            { label: '入账学校', value: res.school },
            { label: '订单类型', value: res.order_type_name },
            { label: '学生姓名', value: res.student_name },
            { label: '学生身份证号/护照号', value: res.student_idcard },
            { label: '缴费学年', value: res.school_year },
            { label: '就读年级', value: res.grade_name },
            { label: '行政班', value: res.class_name },
            { label: '就读校区', value: res.studying_school_name },
            // { label: '当前客户归属招生老师', value: res.belong_teacher }
          ]
          this.list = list
        }).finally(() => {
          this.loading = false
        })
    },
    handleClear() {
      this.formData.payment_detail = []
      this.handleAdd()
    },
    handleAdd() {
      if (this.dynamicMaxlength <= this.formData.payment_detail.length) {
        return this.$message.warning(`最多只能添加${this.dynamicMaxlength}条`);
      }
      this.formData.payment_detail.push({ id: Date.now(), payment_method:'', paid_amount: '', payer: '', payment_at: formatDate().fullDateTime, isAdd: 1 })
    },
    handleDelete(item) {
      const index = this.formData.payment_detail.indexOf(item)
      if (!~index) return
      this.formData.payment_detail.splice(index, 1)
    },
    handelRemove(item) {
      const { id, ...other } = item
      if(objectIsEmpty(other, ['isAdd'])) return this.handleDelete(item)
      this.$confirm('此操作将删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, _instance, done) => {
          if (action === 'confirm') this.handleDelete(item)
          done()
        }
      }).then(() => {
        this.$message({ type: 'success', message: `删除成功!` })
      })
    },
    onStageChange() {
      this.formData.sum_price = ''
      this.formData.sum_remain_price = ''
    },
    onAmountChange(value) {
      if (verifyIsNumber(value, { empty: '请输入实缴金额', positive: true })) {
        this.formData.sum_remain_price = ''
        return
      }
      let v1 = Number(value)
      let v2 = Number(this.money_answer)
      if (v1 >= v2) {
        this.formData.sum_remain_price = ''
        return
      }
      this.formData.sum_remain_price = preciseSubtract(v2, v1)
    },
    handleClick(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return
        if (this.formData.is_pay === 2) return this.$confirm('驳回后家长端订单将自动取消，是否确认驳回?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '再看看',
          type: 'warning'
        }).then(() => {
          this.handleConfirm()
        })
        const { is_by_stages } = this.formData
        const arr = this.formData.payment_detail.filter(i => i.paid_amount)
        const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount)), 0)
        const num = is_by_stages ? Number(this.formData.sum_price) : Number(this.money_answer)
        let msg = ''
        if (this.showMethod && num !== sum) msg = `学生【实缴金额及方式】的累计实缴金额需等于【实缴金额】`
        if (msg) return this.$message.error({ message: msg, duration: 4000 })
        this.handleConfirm()
      })
    },
    handleConfirm() {
      const id = this.$route.query.id
      const { is_pay, is_by_stages, sum_price, sum_remain_price, reason, remark, payment_detail, ...other } = this.formData
      const data = is_pay === 1 ? { id, is_pay, is_by_stages, reason: remark, ...other } : { id, is_pay, reason }
      if (is_pay === 1) {
        data.payment_detail = (sum_price === '' || Number(sum_price)) ? transformAddOrEditData(payment_detail) : [
          {
            payment_method: '现金',
            paid_amount: 0,
            payer: '/',
            payment_at: formatDate().fullDateTime
          }
        ]
        data.payment_at = data.payment_detail[0].payment_at
        data.sum_compute_price = this.money_answer
        data.sum_price = sum_price
        if (is_by_stages) {
          data.sum_first_price = sum_price
          data.sum_remain_price = sum_remain_price
        }
      }
      this.loading = true
      http({ url: '/recruit-v2/order-offline/edit', pre: 'zs', method: 'post'}, data).then(() => {
        // this.$router.replace('/finance/enrollment/offline-payment-approval/look?id=' + id)
        this.$router.back()
      }).finally(() => {
        this.loading = false
      })
    },
    handleBack() {
      this.formBack(this.formData, ['direction_study'])
    }
  }
}
</script>

<style lang="scss" scoped></style>
